// extracted by mini-css-extract-plugin
module.exports = {"desktop-up":"(min-width: calc(1280 * 1px))","big-desktop-up":"(min-width: calc(1600 * 1px))","feed":"Feed_feed__1gqOL","tabsItem":"Feed_tabsItem__1Bojp"};